import { VoucherV2 } from '@linktivity/eticketportal';
import { message } from '@linktivity/link-ui';

const BASE_PATH = import.meta.env.VITE_API_VOUCHER_V2_HOST;

const config = new VoucherV2.Configuration({
  basePath: BASE_PATH,
  middleware: [
    {
      pre: async (context: { init: RequestInit }) => {
        const requestHeaders: HeadersInit = new Headers({
          'Content-Type': 'application/json'
        });
        context.init.headers = requestHeaders;
      },
      post: async (context: { response: Response }) => {
        if (!context.response.ok) {
          // handle error
          const data = await context.response.json();
          message.error(data?.message || data?.details?.[0].reason, 10);
          return data;
        }
      }
    }
  ]
});

const voucherV2 = new VoucherV2.BookingApi(config);

export default voucherV2;
